module.exports = __webpack_public_path__ + "media/images/footer_telegram-1ee7bafa684de61f8cbda5b400664ca9.png";